export default "__VITE_ASSET__B0XUUV99__"